export default __webpack_public_path__ + "static/media/calibration-fourth-step.cf9a448f.png";